import React, { useCallback, useEffect, useState } from 'react';
import TopTips, { Top, TopTip } from '../../Attraction/topTip';
import { EPageType } from '../../../types/pages/things-to-do';
import AddTopTipModal from '../../Attraction/AddTopTipModal';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useAuthContext } from '../../../utils/context/authContext';
import NotificationModal, {
  EModalType
} from '../../../shared-components/NotificationModal/NotificationModal';
import { useRouter } from 'next/router';

interface AttractionTopTipsProps {
  topTips: TopTip[];
}

export const AttractionTopTips = ({ topTips }: AttractionTopTipsProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [toptipText, setToptipText] = useState<string>('');
  const [top, setTop] = useState<Top[]>([]);
  const [citySlug, setCitySlug] = useState<string>('');
  const { user }: any = useAuthContext();
  useEffect(() => {
    const allTops = [{ top_tips: topTips }];
    setTop(allTops);
  }, [topTips]);
  const router = useRouter();

  useEffect(() => {
    if (typeof window !== undefined) {
      const currentURL = window.location.href;
      const parts = currentURL.split('/');
      setCitySlug(parts[parts.length - 1]);
    }
  }, [topTips]);

  const toggleModal = useCallback(() => {
    setShowErrorModal(!showErrorModal);
  }, [showErrorModal]);

  const updateTopTip = async (
    id: string,
    likes: number,
    dislikes: number,
    isLikeClick: boolean
  ) => {
    const url = isLikeClick
      ? `${process.env.NEXT_PUBLIC_FIREBASE_CONNECTION}/like-top-tip/${id}`
      : `${process.env.NEXT_PUBLIC_FIREBASE_CONNECTION}/dislike-top-tip/${id}`;
    const token = await getCurrentToken();
    const data = {
      slug: citySlug
    };
    const headers = {
      Authorization: token,
      'Content-Type': 'application/json'
    };
    try {
      const response = await axios.put(url, data, { headers });
      if (isLikeClick) {
        setTop(prevTop => {
          const newTop = prevTop.map(top => {
            return {
              ...top,
              top_tips: top.top_tips.map(tip =>
                tip.id == id
                  ? {
                      ...tip,
                      likes: response.data.tip.likes,
                      dislikes: response.data.tip.dislikes,
                      liked: !tip.liked,
                      disliked: tip.disliked ? !tip.disliked : tip.disliked
                    }
                  : tip
              )
            };
          });
          return newTop;
        });
      } else {
        setTop(prevTop => {
          const newTop = prevTop.map(top => {
            return {
              ...top,
              top_tips: top.top_tips.map(tip =>
                tip.id == id
                  ? {
                      ...tip,
                      likes: response.data.tip.likes,
                      dislikes: response.data.tip.dislikes,
                      liked: tip.liked ? !tip.liked : tip.liked,
                      disliked: !tip.disliked
                    }
                  : tip
              )
            };
          });
          return newTop;
        });
      }
    } catch (error) {
      console.error('Error updating top tip:', error);
    }
  };

  const getCurrentToken = async () => {
    try {
      if (user) {
        const idToken = await user.getIdToken();
        return idToken;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error fetching ID token:', error);
      return null;
    }
  };
  const handleSubmit = async () => {
    const url = `${process.env.NEXT_PUBLIC_FIREBASE_CONNECTION}/add-top-tip/${citySlug}`;
    const token = await getCurrentToken();
    const data = {
      tip: toptipText
    };
    const headers = {
      Authorization: token,
      'Content-Type': 'application/json'
    };
    try {
      const response = await axios.post(url, data, { headers });
      const updatedTopTip = response.data;
      const newTopTip = {
        id: updatedTopTip.id,
        text: updatedTopTip.text,
        likes: 0,
        dislikes: 0
      };
      toast.success('Tip added successfully');
      setTop(prevTop => {
        const updatedTop = {
          ...prevTop[0],
          top_tips: [newTopTip, ...prevTop[0].top_tips]
        };
        return [updatedTop, ...prevTop.slice(1)];
      });
      setIsModalOpen(false);
      setToptipText('');
    } catch (axiosError: any) {
      if (
        axiosError.response &&
        axiosError.response.data &&
        axiosError.response.data.error
      ) {
        const firebaseError = axiosError.response.data.error;

        if (
          firebaseError.includes(
            'Firebase ID token has expired. Get a fresh ID token from your client app and try'
          )
        ) {
          toast.error(
            'Firebase ID token has expired. Please refresh the token.'
          );
        }
      } else {
        if (axiosError.response.data.message)
          toast.error(axiosError.response.data.message);
      }
      setIsModalOpen(false);
      setToptipText('');
    }
  };
  return (
    <div className="w-[90%] md:w-[85%] xl:w-[80%] 3xl:w-[70%] mx-auto flex flex-col">
      <TopTips
        setIsModalOpen={setIsModalOpen}
        top={top}
        updateTopTip={updateTopTip}
        pageType={EPageType.THINGS_TODO}
        setShowErrorModal={setShowErrorModal}
      />
      {isModalOpen && (
        <AddTopTipModal
          top={top}
          toptipText={toptipText}
          setToptipText={setToptipText}
          handleSubmit={handleSubmit}
          setIsModalOpen={setIsModalOpen}
          pageType={EPageType.THINGS_TODO}
        />
      )}
      {showErrorModal && (
        <NotificationModal
          toggleModal={toggleModal}
          modalType={EModalType.ERROR}
          message="To access this feature, please log in to your account first."
          buttonText="Sign in"
          buttonHandler={() => router.push('/signin')}
        />
      )}
    </div>
  );
};
